// @flow
import React, { Component } from 'react';
import Circles from 'components/common/Loaders/Circles';
import CartTemplate from 'components/cart/CartTemplate';
import type { State } from 'store';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { track, TRACKING_EVENTS } from 'lib/tracking';
import { CartActions } from '../../store/actionCreators';
import axios from '../../lib/defaultClient';

type Props = {
  logged: boolean,
  cart: any,
  items: any,
  gradeDiscount: any,
};

class CartTemplateContainer extends Component<Props> {
  state = {
    initLoading: true,
  };

  initialize = async () => {
    this.setState({ initLoading: true });
    try {
      if (this.props.logged) {
        await CartActions.getCart();
      } else {
        await CartActions.getAsNonRegisteredCart({ items: window.CacheBy.LocalCart.items });
      }
      this.trackCartViewed();
      this.setState({ initLoading: false });
    } catch (e) {
      console.log(e);
    }
  };

  trackCartViewed = () => {
    const { cart } = this.props;
    if (!cart || !cart.items) return;
    const items = cart.items.map(item => ({
      productId: item.product.id,
      productTitle: item.product.title,
      price: item.price,
      quantity: item.quantity,
    }));
    const value = cart.items.reduce((sum, item) => {
      const price = item.price && item.price.sale ? Number(item.price.sale.raw) || 0 : 0;
      const quantity = Number(item.quantity) || 0;
      return sum + price * quantity;
    }, 0);
    track(TRACKING_EVENTS.CART_VIEWED, { items, value });
  };

  componentDidMount() {
    this.initialize();
  }

  // 전체 체크
  allCheckedCart() {
    CartActions.allCheckedCart();
  }

  // 한개 체크
  updateCheckedCart(index) {
    CartActions.updateCheckedCart(index);
  }

  // 수량 변경
  updateItemCart = async (index, itemId, payload) => {
    if (this.props.logged) {
      await CartActions.updateItemCart(index, itemId, {
        quantity: Number(payload.target.value),
      });
    } else {
      await CartActions.updateItemAsNonRegisteredCart({
        index,
        itemId,
        quantity: Number(payload.target.value),
      });
    }
  };

  // 전체상품 삭제
  emptyCart = async () => {
    if (this.props.logged) {
      await CartActions.emptyCart();
    } else {
      await CartActions.emptyAsNonRegisteredCart();
    }
  };

  // 선택상품 삭제
  deleteItemCheckedCart = async () => {
    if (this.props.cart.items.length) {
      for (let index = 0; index < this.props.cart.items.length; index += 1) {
        if (this.props.cart.items[index].checked === true) {
          const itemId = this.props.cart.items[index].id;
          if (this.props.logged) {
            // eslint-disable-next-line no-await-in-loop
            await CartActions.deleteItemCart(itemId);
            index -= 1;
          } else {
            CartActions.deleteItemAsNonRegisteredCart({ itemId });
          }
        }
      }
    }
  };

  // 단일상품 삭제
  deleteItemCart = async itemId => {
    const item = this.props.cart.items.find(i => i.id === itemId);
    if (item) {
      track(TRACKING_EVENTS.PRODUCT_CART_REMOVED, {
        productId: item.product.id,
        productTitle: item.product.title,
        quantity: item.quantity,
      });
    }
    if (this.props.logged) {
      await CartActions.deleteItemCart(itemId);
    } else {
      CartActions.deleteItemAsNonRegisteredCart({ itemId });
    }
  };

  onOffer = () => {
    if (this.props.cart.items.filter(item => item.checked === true).length) {
      this.props.history.push('/offer');
    } else {
      alert('상품을 선택 해주세요.');
    }
  };

  onShopping = () => {
    this.props.history.push('/');
  };

  onOrder = () => {
    if (this.props.cart.items.filter(item => item.checked === true).length) {
      if (this.props.logged) {
        this.props.history.push('/checkout');
      } else {
        this.props.history.push(`/login?next=/checkout`);
      }
    } else {
      alert('상품을 선택 해주세요.');
    }
  };

  goProduct = async id => {
    if (!id) return;
    try {
      const result = await axios.get(`/products/url/${id}`);
      this.props.history.push(result.data);
    } catch (e) {
      console.error('goProduct error:', e);
    }
  };

  render() {
    if (this.state.initLoading) return <Circles color="blue" size="medium" text="Loading..." />;

    return (
      <CartTemplate
        cart={this.props.cart}
        items={this.props.cart.items}
        goProduct={this.goProduct}
        allCheckedCart={this.allCheckedCart}
        updateCheckedCart={this.updateCheckedCart}
        updateItemCart={this.updateItemCart}
        emptyCart={this.emptyCart}
        deleteItemCheckedCart={this.deleteItemCheckedCart}
        deleteItemCart={this.deleteItemCart}
        removeSelectedCart={this.deleteItemCheckedCart}
        removeAllCart={this.emptyCart}
        onOffer={this.onOffer}
        onShopping={this.onShopping}
        onOrder={this.onOrder}
        gradeDiscount={this.props.gradeDiscount}
      />
    );
  }
}

export default connect(
  ({ cart, user, pender }: State) => ({
    cart,
    items: cart.items,
    logged: !!user.user,
    loading: pender.pending['cart/GET_CART'],
    loading1: pender.pending['cart/GET_AS_NON_REGISTERED_CART'],
    gradeDiscount: (user.user && user.user.grade.value) || 0,
  }),
  () => ({}),
)(withRouter(CartTemplateContainer));



// WEBPACK FOOTER //
// ./src/containers/cart/CartTemplateContainer.js